import { Fan, Waypoints, Flame, Zap } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const GROUPS = [
  {
    icon: Fan,
    title: "Bombas, recalque e pressurização",
    desc: "Serviços relacionados a motobombas de recalque, bombas submersas, sistemas de bombeamento e pressurizadores, conforme as características da instalação.",
  },
  {
    icon: Waypoints,
    title: "Instalações e redes hidráulicas",
    desc: "Instalação, manutenção, reparo e adequação de redes hidráulicas em PVC, PEX, cobre, PPR e CPVC, de acordo com a necessidade do projeto.",
  },
  {
    icon: Flame,
    title: "Aquecimento de água",
    desc: "Instalação e manutenção de sistemas de aquecimento de água, incluindo aquecedores a gás, boilers e sistemas de aquecimento solar, conforme os equipamentos atendidos pela HidroPro Serviços Técnicos.",
    items: ["Troca de resistências", "Termostatos", "Válvulas"],
  },
  {
    icon: Zap,
    title: "Elétrica e painéis de comando",
    desc: "Instalação e manutenção de sistemas elétricos residenciais e prediais, incluindo manutenção e adequação de painéis de comando e sistemas de acionamento de motobombas.",
  },
];

export default function Hidraulica() {
  return (
    <section id="servicos" className="relative bg-white py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          index="02"
          label="Serviços"
          title="Serviços hidráulicos e elétricos"
          lead="A HidroPro oferece serviços técnicos para instalações residenciais e prediais, incluindo sistemas de bombeamento, redes hidráulicas, aquecimento de água e instalações elétricas."
        />

        <div data-testid="hidropro-hydraulic-solutions-grid" className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:mt-16 lg:gap-6">
          {GROUPS.map((s, i) => (
            <Reveal key={s.title} delay={(i % 2) * 0.08} className="h-full">
              <article className="group relative flex h-full flex-col overflow-hidden rounded-xl border border-[rgba(10,92,140,0.14)] bg-paper p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#0A5C8C]/45 hover:shadow-[0_18px_44px_rgba(10,92,140,0.16)] sm:p-7">
                <span className="absolute inset-x-0 top-0 h-[3px] origin-left scale-x-0 bg-gradient-to-r from-[#0A5C8C] to-[#00A3E0] transition-transform duration-300 group-hover:scale-x-100" />
                <div className="flex items-start justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#0A5C8C]/10 text-[#0A5C8C] transition-colors duration-300 group-hover:bg-[#0A5C8C] group-hover:text-white">
                    <s.icon className="h-5 w-5" />
                  </span>
                  <span className="font-mono text-xs tracking-[0.2em] text-[#0A5C8C]/45">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <h3 className="mt-5 font-display text-xl font-semibold tracking-tight text-[#0A5C8C]">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                {s.items && (
                  <div className="mt-4 flex flex-wrap gap-2 pt-2">
                    {s.items.map((item) => (
                      <span key={item} className="rounded-full border border-[rgba(10,92,140,0.25)] bg-white px-3 py-1 text-xs font-medium text-[#0A5C8C]">
                        {item}
                      </span>
                    ))}
                  </div>
                )}
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-12 lg:mt-16">
          <figure className="relative overflow-hidden rounded-2xl" data-testid="hidropro-hydraulic-photo">
            <img
              src="https://images.unsplash.com/photo-1676210134190-3f2c0d5cf58d?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Técnico HidroPro realizando serviço em aquecedor de água"
              loading="lazy"
              className="h-[280px] w-full object-cover sm:h-[380px]"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-brand-ink/85 via-brand-ink/30 to-transparent" />
            <figcaption className="absolute bottom-5 left-5 max-w-sm sm:bottom-8 sm:left-8">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-water">Atendimento técnico</p>
              <p className="mt-2 font-display text-lg font-bold leading-snug text-white sm:text-2xl">
                Serviços técnicos em sistemas hidráulicos, bombeamento e aquecimento de água, com avaliação conforme as
                características de cada instalação.
              </p>
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
}
